import { SingleValue } from './SingleValue';

export default SingleValue;
